import company_image from '../img/trameco2.png';

export default function Logo({style = "h-8"}) {
  return (
    <img class={style+" w-auto"} src={company_image} alt="Your Company"/>
  )
}